import {Injectable} from '@angular/core';
import { CplTimeTrackingReportRequest } from '../../model/cpl-time-tracking-report-reqest.model';
import { ReportsApi } from 'src/app/api/reports/reports.api';

@Injectable()
export class ReportsService {
    constructor(private  reportsApi: ReportsApi) { }

    getTimeReport = ( request:CplTimeTrackingReportRequest) => this.reportsApi.getTimeReport(request)

    getTimeReportExport = ({ userId, startDate, endDate }) => this.reportsApi.getTimeReportExport({ userId, startDate, endDate })

}